module.exports = __webpack_public_path__ + "static/media/2.5e7c462e.jpg";